import { render, staticRenderFns } from "./chatlogin.vue?vue&type=template&id=47ede121&scoped=true&"
import script from "./chatlogin.vue?vue&type=script&lang=js&"
export * from "./chatlogin.vue?vue&type=script&lang=js&"
import style0 from "./chatlogin.vue?vue&type=style&index=0&id=47ede121&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ede121",
  null
  
)

export default component.exports